var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.date)?_c('time',[(_vm.end && _vm.date !== _vm.end)?[_vm._v(" "+_vm._s(_vm.dateFormatted)+" – "+_vm._s(_vm.endFormatted)+" ")]:[_vm._v(" "+_vm._s(_vm.dateFormatted)+" ")]],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }